import React from 'react';
import ReactTooltip from 'react-tooltip';
import styles from './systemEventTimelineStyles.scss';
import MatchedFilterInfoButton from './MatchedFilterInfoButton';
import { formatDisplayDate } from './ShipmentEventUtils';

const ShipmentFilterRow = ({
  filter,
  isExpanded,
  onToggle,
}) => {
  const filterActivities = filter.events || [];

  const displayTimestamp = filterActivities.reduce((latest, ev) => {
    if (!ev.timestamp) return latest;
    return !latest || ev.timestamp > latest ? ev.timestamp : latest;
  }, null);

  const hasActivities = filterActivities.length > 0;

  return (
    <div className={styles.dropdownFilterRow}>
      <div className={styles.filterRowBox}>
        {hasActivities ? (
          <button
            type="button"
            className={styles.dropdownFilterToggle}
            onClick={onToggle}
            aria-expanded={isExpanded}
          >
            <span className={styles.dropdownFilterPrimaryText}>{filter.name}</span>
            <span
              className={styles.filterTimestamp}
              data-tip
              data-for={`filter-timestamp-tooltip-${filter.id}`}
              style={{ cursor: 'help' }}
            >
              {formatDisplayDate(displayTimestamp)}
            </span>

            <ReactTooltip
              id={`filter-timestamp-tooltip-${filter.id}`}
              effect="float"
              place="auto"
            >
              Date the filter was last triggered.
            </ReactTooltip>

            <span className={`${styles.chevron} ${isExpanded ? styles.chevronDown : styles.chevronRight}`} />
          </button>
        ) : (
          <div className={styles.dropdownFilterToggle} style={{ cursor: 'default' }}>
            <span className={styles.dropdownFilterPrimaryText}>{filter.name}</span>
            <span
              className={styles.filterTimestamp}
              data-tip
              data-for={`filter-timestamp-tooltip-${filter.id}`}
              style={{ cursor: 'help' }}
            >
              {formatDisplayDate(displayTimestamp)}
            </span>

            <ReactTooltip
              id={`filter-timestamp-tooltip-${filter.id}`}
              effect="float"
              place="auto"
            >
              Date the filter was last triggered.
            </ReactTooltip>

            <span style={{ display: 'inline-block', width: '6px', height: '6px' }} />
          </div>
        )}

        <MatchedFilterInfoButton filter={filter} onToggle={onToggle} />
      </div>

      {hasActivities && isExpanded && (
        <div className={styles.notificationActivityMeta}>
          <ul className={styles.activityList}>
            {filterActivities.map((event, i) => {
              const isPrevented = Boolean(event.is_prevented);
              const isError = Boolean(event.is_error);

              return (
                <li
                  // eslint-disable-next-line react/no-array-index-key
                  key={`${filter.id}-${i}`}
                  className={`${styles.activityItem} ${isPrevented ? styles.activityItemPrevented : ''} ${isError ? styles.activityItemError : ''}`}
                >
                  <span className={styles.activityDescription}>
                    {event.description}
                  </span>
                  <span className={styles.activityStatus}>
                    {event.status && (
                      <span
                        data-tip="Http status code returned by the activity."
                        data-for={`activity-status-tooltip-${filter.id}`}
                        style={{ cursor: 'help' }}
                      >
                        {event.status}
                      </span>
                    )}
                  </span>
                  <span
                    className={styles.activityTime}
                    data-tip="Date the activity occurred."
                    data-for={`activity-time-tooltip-${filter.id}`}
                    style={{ cursor: 'help' }}
                  >
                    {event.timestamp ? formatDisplayDate(event.timestamp) : ''}
                  </span>
                </li>
              );
            })}
            <ReactTooltip id={`activity-status-tooltip-${filter.id}`} effect="float" place="auto" />
            <ReactTooltip id={`activity-time-tooltip-${filter.id}`} effect="float" place="auto" />
          </ul>
        </div>
      )}
    </div>
  );
};

export default ShipmentFilterRow;
